import { Controller } from "@hotwired/stimulus";

// The three cadences ask for different fields, so only the chosen one's inputs are
// shown. The others stay in the document rather than being removed, because the server
// ignores the fields a cadence does not use and re-showing them must not lose what was
// typed before.
export default class extends Controller {
  static targets = ["mode", "days", "interval", "cycle", "anchor", "weekday", "times", "timeTemplate"];

  connect() {
    this.render();
  }

  render() {
    const mode = this.modeTargets.find((input) => input.checked)?.value;

    this.daysTarget.classList.toggle("hidden", mode !== "weekdays");
    this.intervalTarget.classList.toggle("hidden", mode !== "interval");
    this.cycleTarget.classList.toggle("hidden", mode !== "cycle");
    this.anchorTarget.classList.toggle("hidden", mode !== "interval" && mode !== "cycle");
  }

  clearDays() {
    this.weekdayTargets.forEach((input) => {
      input.checked = false;
    });
  }

  selectEveryDay() {
    this.weekdayTargets.forEach((input) => {
      input.checked = true;
    });
  }

  addTime() {
    this.timesTarget.insertAdjacentHTML("beforeend", this.timeTemplateTarget.innerHTML);
    this.renderTimes();
  }

  removeTime(event) {
    event.target.closest("[data-time-row]").remove();
    this.renderTimes();
  }

  // A protocol has to keep at least one time, so the last row cannot be removed. The
  // server would reject an empty schedule anyway; hiding the control says so sooner.
  renderTimes() {
    const rows = this.timesTarget.querySelectorAll("[data-time-row]");

    rows.forEach((row) => {
      row.querySelector("[data-time-remove]").classList.toggle("invisible", rows.length === 1);
    });
  }
}
